<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SummaryListItem from '@/components/partials/display/SummaryListItem.vue'
import HelpText from '@/components/partials/display/HelpText.vue'
import { useWidgetText } from '@/helpers/useWidgetText'
import { renderSimplifiedSummary } from '@/helpers/render-simplified-summary'

const { t } = useI18n()
const { wt: wtSummary } = useWidgetText('widget-texts-project-summary')
const { wt: wtProjectGeneral } = useWidgetText('widget-texts-project-general')

const props = defineProps({
  quantityArea: { type: Number, required: true },
  usages: {
    type: Array as () => Array<{ title: string; ratio: number }>,
    required: true,
  },
  landscapeQuantityArea: { type: Number, required: false, default: undefined },
  landscapeUsages: {
    type: Array as () => Array<{ title: string; ratio: number }>,
    required: false,
    default: () => [],
  },
  civilEngineerSlabArea: { type: Number, required: false, default: undefined },
  totalHours: { type: Number, required: true },
})

const simplifiedSummary = computed(() =>
  renderSimplifiedSummary(
    {
      quantityArea: props.quantityArea,
      usages: props.usages,
      landscapeQuantityArea: props.landscapeQuantityArea,
      landscapeUsages: props.landscapeUsages,
      civilEngineerSlabArea: props.civilEngineerSlabArea,
      totalHours: props.totalHours,
    },
    t,
    wtSummary,
    wtProjectGeneral
  )
)
</script>

<template>
  <div>
    <h2 class="mb-2 text-xl">{{ wtSummary('summary', 'title') }}</h2>
    <HelpText slug="project_summary" />
    <p class="mb-4 text-sm text-neutral-450">
      {{ wtSummary('summary', 'subtitle') }}
    </p>
  </div>
  <section class="mt-12 border-b border-neutral-300">
    <h3 class="mb-4 text-lg text-neutral-650">{{ wtSummary('summary', 'overall', 'title') || 'Overall' }}</h3>
    <SummaryListItem v-for="item in simplifiedSummary.summaryList" :key="item.title" v-bind="item" />
  </section>
  <section
    v-for="section in simplifiedSummary.summaryUsageSections"
    :key="section.title"
    class="mt-12 border-b border-neutral-300">
    <h3 class="mb-4 text-lg text-neutral-650">{{ section.title }}</h3>
    <SummaryListItem v-for="item in section.items" :key="item.title" v-bind="item" />
  </section>
</template>
